import React from 'react';
import { Text, Stack } from '@chakra-ui/react';
import { AlertDialogConfirmationModal } from 'app/shared-components';
import { projects } from '@xmcloud/core/messages/en';
import { t } from '@transifex/native';

const { convertProjectTitle, confirmConvert } = projects;

interface Props {
	openModal: boolean;
	setOpenModal: (open: boolean) => void;
	onConfirm: () => void;
	isLoading?: boolean;
}

const ConvertProjectModal: React.FC<Props> = ({
	openModal,
	setOpenModal,
	onConfirm,
	isLoading = false,
}) => {
	return (
		<AlertDialogConfirmationModal
			isOpen={openModal}
			title={t(convertProjectTitle)}
			onClose={() => setOpenModal(false)}
			dataTestId="convert-project-confirmation-modal"
			isLoading={isLoading}
			onConfirm={onConfirm}
			leftButtonText={confirmConvert}
			colorScheme="primary"
			featureTag="Deploy - Projects - Convert Project Button Clicked"
		>
			<Stack spacing={4}>
				<Text>
					This action updates your project to build and deploy your
					Authoring Environment and Editing Hosts separately, enabling
					faster and more flexible deployments. Your setup will remain
					linked to your current source code repository, and new
					deployments will be triggered during this process.
				</Text>
				<Text>
					<Text as="span" fontWeight="bold">
						Important:
					</Text>
					<br />
					No data, including databases, will be affected. For
					assistance or to revert to your previous setup, contact
					Sitecore Support.
				</Text>
			</Stack>
		</AlertDialogConfirmationModal>
	);
};

export default ConvertProjectModal;
